import React from 'react';
import {ReactComponent as Behance} from 'assets/svgs/social/behance.svg';
import {ReactComponent as Instagram} from 'assets/svgs/social/instagram.svg';
import {ReactComponent as Linkedin} from 'assets/svgs/social/linkedin.svg';
import {ReactComponent as Pinterest} from 'assets/svgs/social/pinterest.svg';
import {ReactComponent as Twitter} from 'assets/svgs/social/twitter.svg';
import {ReactComponent as Vimeo} from 'assets/svgs/social/vimeo-social.svg';
import {ReactComponent as Youtube} from 'assets/svgs/social/youtube.svg';
import {ReactComponent as Facebook} from 'assets/svgs/social/facebook.svg';
import './style.scss';

const Socials = ({data}) => {
  const links = {
    facebookLink: <Facebook />,
    twitterLink: <Twitter />,
    instagramLink: <Instagram />,
    pininterestLink: <Pinterest />,
    youtubeLink: <Youtube />,
    vimeoLink: <Vimeo />,
    linkedLink: <Linkedin />,
    behancLink: <Behance />,
  };

  const hasValue = Object.keys(links).filter((f) => data[f]);

  const getUrl = (url) =>
    url.toLowerCase().startsWith('http') ? url : `https://${url}`;

  return (
    <div className="d-flex social-icons">
      {hasValue.map((link) => (
        <a
          key={link}
          href={getUrl(data[link])}
          className="mr-2"
          target="_blank"
        >
          {links[link]}
        </a>
      ))}
    </div>
  );
};

export default Socials;
